import { render, staticRenderFns } from "./era-of-women.vue?vue&type=template&id=7bdd94da&"
import script from "./era-of-women.vue?vue&type=script&lang=js&"
export * from "./era-of-women.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports